{
  "(optional)": "(opcionális)",
  "(required)": "(kötelező)"
}